import { buildHelpRequestPayload } from '../helpRequest';
import { ReviewMethodMessageView } from './ReviewMethodMessageView';
import { ReviewMethodSelectorView } from './ReviewMethodSelectorView';
import { parseReviewMethodOptions } from './parseOptions';
import { parseReviewMethodReply } from './parseReply';
import type { GenerativeUiDescriptor, GenerativeUiDisplayPayload } from '../types';
import type { ReviewMethodOptions } from './parseOptions';
import type { ReviewMethodReply } from './parseReply';

function parseReviewMethodDisplayPayload(
    data: unknown
): GenerativeUiDisplayPayload<'review-method', ReviewMethodReply> | null {
    const reply = parseReviewMethodReply(data);
    if (!reply) return null;
    return { type: 'review-method', data: reply };
}

export const reviewMethodDescriptor: GenerativeUiDescriptor<
    'review-method',
    ReviewMethodOptions,
    ReviewMethodReply
> = {
    type: 'review-method',
    parseReply: parseReviewMethodReply,
    parseDisplayPayload: parseReviewMethodDisplayPayload,
    MessageView: ReviewMethodMessageView,
    render: (data) => {
        const payload = parseReviewMethodDisplayPayload(data);
        if (!payload) return null;
        return <ReviewMethodMessageView data={payload.data} />;
    },
    parseOptions: parseReviewMethodOptions,
    renderSelector: (data, onSubmit) => {
        const options = parseReviewMethodOptions(data);
        if (!options) return null;
        return (
            <ReviewMethodSelectorView
                options={options}
                onSubmit={onSubmit}
                onRequestHelp={() =>
                    onSubmit(
                        buildHelpRequestPayload(
                            'review-method',
                            options.options.map(({ name }) => ({ name }))
                        )
                    )
                }
            />
        );
    },
};
